module.exports = __webpack_public_path__ + "img/trans-AI.d8124521.svg";